import { CircularProgress, Stack, Typography } from '@mui/material';

interface LoadingSpinnerProps {
  /**
   * Optional status message rendered below the spinner. Used by remote-app
   * shells to surface retry progress (e.g. "Retrying… (attempt 1 of 3)").
   * When unset, the bare-spinner UI is preserved so existing callers don't
   * inherit a layout shift.
   */
  message?: string;
}

/**
 * In-layout CircularProgress loader (nav chrome visible).
 * Pre-Layout / no-nav boot screens use `FullPageWandLoader` instead.
 */
export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: '100%',
        height: '100%',
        // Fallback when a parent has no computed height (e.g. section loaders).
        minHeight: 400,
      }}
    >
      <Stack spacing={2} alignItems="center">
        <CircularProgress size={60} />
        {message && (
          <Typography
            variant="body2"
            color="text.secondary"
            data-testid="psp-loading-spinner-message"
            aria-live="polite"
          >
            {message}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
